import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const Index = lazy(() => import('./Index'))
const TimelineIndex = lazy(() => import('./timeline/Index'))
const TimelineWeekIndex = lazy(() => import('./timeline/WeekIndex'))

export const DevRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--dev']}>
    <Route index element={<Index />} />
    <Route path='timeline' element={<TimelineIndex />} />
    <Route path='timeline/week' element={<TimelineWeekIndex />} />
  </SubRouter>
))
